module.exports = __webpack_public_path__ + "media/images/front/team-34a915e4db11f2115eb6806636c3e313.webp";